<template>
    <div class="field">
        <p class="control has-icons-left">
            <input :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                   v-bind="$attrs"
                   v-validate="'required|email'"
                   @input="handleInputChange"
                   ref="input" />
            <span class="icon is-small is-left has-text-info">
                <i class="far fa-envelope"></i>
            </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "email",
        inject: ["$validator"],
        props: {
            inputValue: { required: true, default: "" }
        },
        data: () => ({ value: null, displayValue: null }),
        methods: {
            handleInputChange() {
                this.value = this.$refs.input.value
                this.$emit("update:inputValue", this.value);
            }
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/email.vue